export default function setInputError(element, focus) {
  if (element === "") {
    $(".KaterInputError").removeClass("KaterInputError");
  } else {
    let tagName = $(element).prop('tagName');
    if (tagName && $(element).hasClass("KaterInputError") === false) {
      const elementType = tagName.toLowerCase();
      $(element).addClass("KaterInputError");
      if (elementType === "input" || elementType === "textarea") {
        $(element).on('input', function () {
          $(element).removeClass("KaterInputError");
        });
      } else if (elementType === "div" || elementType === "select") {
        $(element).on('mouseup', function () {
          $(element).removeClass("KaterInputError");
        });
      }
      if (focus === true) {
        if ($(".ModalManager").length === 0) {
          $("html, body").animate({
            scrollTop: $(element).offset().top - 80
          }, 500);
        } else {
          $(".ModalManager").animate({
            scrollTop: $(element).offset().top + 50
          }, 500);
        }
      }
    }
  }
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/setInputError', setInputError);